/* @flow */
export const FETCH_ALERT_NAME: string = 'FETCH_ALERT_NAME';
export const FETCH_ALERT_NAME_SUCCESS: string = 'FETCH_ALERT_NAME_SUCCESS';
export const FETCH_ALERT_NAME_ERROR: string = 'FETCH_ALERT_NAME_ERROR';
export type AlertNameTypeAction = {
    type: string,
    payload?: Object,
};
